import styled from 'styled-components';
import { VehicleInfoHeader } from './Header';
import { Actions } from './Actions';
import { BlueBookInfo } from './BlueBookInfo';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const VehicleInfo = () => {
  return (
    <Wrapper>
      <VehicleInfoHeader />
      <BlueBookInfo />
    </Wrapper>
  );
};
